import { IconFont, Input, pointer, singleTextEllipsis, tinyButtons } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`

export const SearchInput: typeof Input = styled(Input)`
    width: 100%;
    margin-bottom: 17px;
    border-radius: 6px;
    flex-shrink: 0;
    &:focus-within {
        border-color: var(--color-app-main);
    }
`

export const Icon = styled(IconFont)``

export const TagList = styled.div`
    flex: 1;
    overflow-y: auto;
    ${tinyButtons}
    width: 100%;
`

export const TagWrapper = styled.div`
    height: auto;
    border: 1px solid var(--color-gray-200);
    border-radius: 8px;
    overflow: hidden;
`

export const TagItem = styled.div<{ isShowBorder?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 16px;
    color: var(--color-black);
    border-bottom: 1px solid var(--color-gray-200);
    background: var(--color-white);

    :last-child {
        border: none;
    }
`

export const TagItemContent = styled.div`
    /* margin-right: 6px; */
    font-size: var(--font-size-normal);
    display: flex;
    align-items: center;
    ${singleTextEllipsis}
`

export const FinishButton = styled.div`
    font-weight: 500;
    color: var(--color-app-main);
    ${pointer}
`
